import { useEffect, useState } from 'react';
import {
  Button,
  Form,
  Modal,
  Table,
  Pagination,
  Container,
  Dropdown,
  Badge,
} from 'react-bootstrap';
// import "react-toastify/dist/ReactToastify.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { FaChevronDown } from 'react-icons/fa';
import './fournisseur.css';
import 'react-datepicker/dist/react-datepicker.css';
import TablePagination from './components/TablePagination';
import { BounceLoader } from 'react-spinners';
import { getFournisseursEntetes } from '../../../data/fournisseus';
import ReglementExpand from './components/ReglementExpand';
import FilterDropdown from './components/FilterDropdown';
// import FilterBadgeProd from '../produits/components/FilterBadgeProd';
import FilterBadgeEnt from './components/FilterBadgeEnt';
import { MdFilterListOff } from 'react-icons/md';

export default function SuiviFournisseur() {
  const [fournisseurs, setFournisseurs] = useState([]);
  const [expandedIds, setExpandedIds] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedMonths, setSelectedMonths] = useState([]);
  const mois = [
    { value: '01', label: 'Janvier' },
    { value: '02', label: 'Février' },
    { value: '03', label: 'Mars' },
    { value: '04', label: 'Avril' },
    { value: '05', label: 'Mai' },
    { value: '06', label: 'Juin' },
    { value: '07', label: 'Juillet' },
    { value: '08', label: 'Août' },
    { value: '09', label: 'Septembre' },
    { value: '10', label: 'Octobre' },
    { value: '11', label: 'Novembre' },
    { value: '12', label: 'Décembre' },
  ];

  const filters = [
    {
      key: 'mois',
      label: 'Filtrer par mois',
      type: 'select',
      options: mois,
      state: selectedMonths,
      setter: setSelectedMonths,
      isMulti: true,
      placeholder: 'Choisir le mois',
      extraOnChange: () => setPage(1),
    },
  ];

  const CustomMultiValue = () => {
    return null;
  };

  const fetchFournisseurs = async () => {
    try {
      setIsLoading(true);
      const fournisseurs = await getFournisseursEntetes();
      setFournisseurs(fournisseurs);
    } catch (error) {
      console.error('Error fetching fournisseurs:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFournisseurs();
  }, []);

  const handleIdExpandClick = compositeId => {
    if (compositeId === 'all') {
      if (expandedIds.length === fournisseurs.length) {
        setExpandedIds([]);
      } else {
        setExpandedIds(fournisseurs.map(s => s.id));
      }
    } else {
      setExpandedIds(prev =>
        prev.includes(compositeId) ? prev.filter(id => id !== compositeId) : [...prev, compositeId]
      );
    }
  };

  const renderFournisseurs = () => {
    return fournisseurs.filter(f => {
      const clientNormalized = f.client.toLowerCase().trim();
      const searchNormalized = searchTerm.toLowerCase().trim();

      const matchesSearch = searchNormalized === '' || clientNormalized.includes(searchNormalized);

      return matchesSearch;
    });
  };

  const badgesLength = (searchTerm.trim() !== '' ? 1 : 0) + selectedMonths.map(m => m.value).length;

  const [page, setPage] = useState(1);
  const perPage = 50;
  return (
    <Container fluid>
      <div className="pt-4">
        <div className="d-flex justify-content-between">
          <h2>Factures Fournisseurs</h2>
        </div>
        <div className="table-container">
          {isLoading && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '20px 0',
              }}
            >
              <BounceLoader size={150} color="#007bff" />
            </div>
          )}
          {!isLoading && (
            <Table className="fournisseurs" hover>
              <thead className="fournisseur-header1">
                <tr className="fournisseur-first-header">
                  <th className="fournisseur-first-header-col"> Id</th>
                  <th className="expand"></th>
                  <th>Client</th>
                  <th>Montant Total</th>
                  <th>Estimation Total</th>
                  <th>Reglement Total</th>
                  <th className="fournisseur-last-header-col">Reste a payer</th>
                </tr>
                <tr className="fournisseur-second-header">
                  <th colSpan={7}>
                    <div className="filter-container">
                      <div className=" expand-toggle" onClick={() => handleIdExpandClick('all')}>
                        <FaChevronDown
                          size={14}
                          style={{
                            color: 'black',
                            transform:
                              expandedIds.length === fournisseurs.length
                                ? 'rotate(180deg)'
                                : 'rotate(0deg)',
                            transition: 'transform 0.2s ease',
                          }}
                        />
                      </div>
                      <div className="filter-item search-container">
                        <div className="search-badges d-flex flex-wrap gap-1 mb-2">
                          <FilterBadgeEnt
                            selectedEle={selectedMonths}
                            setSelectedEle={setSelectedMonths}
                            type="month"
                          />
                          {badgesLength > 0 && (
                            <Badge
                              bg="danger"
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                setSearchTerm('');
                                setSelectedMonths([]);
                                setPage(1);
                              }}
                            >
                              <MdFilterListOff />
                            </Badge>
                          )}
                        </div>
                        <Form.Control
                          placeholder="Nom, Code, ou Remise du produit"
                          type="text"
                          name="filtre"
                          value={searchTerm}
                          onChange={e => setSearchTerm(e.target.value)}
                        />
                      </div>
                      <FilterDropdown CustomMultiValue={CustomMultiValue} filters={filters} />
                      <div className="filter-item td-large fixed">
                        <TablePagination
                          page={page}
                          setPage={setPage}
                          renderElements={renderFournisseurs}
                          elements={fournisseurs}
                          perPage={perPage}
                        />
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {renderFournisseurs()
                  .slice((page - 1) * perPage, page * perPage)
                  .map(fournisseur => (
                    <>
                      <tr className="data-row" key={fournisseur.id}>
                        <td className="fournisseur-datacell id-datacell" title={fournisseur.id}>
                          <span className="id-text">{fournisseur.id}</span>
                        </td>
                        <td
                          className="fournisseur-datacell expand"
                          onClick={() => handleIdExpandClick(fournisseur.id)}
                        >
                          <FaChevronDown
                            size={14}
                            style={{
                              transform: expandedIds.includes(fournisseur.id)
                                ? 'rotate(180deg)'
                                : 'rotate(0deg)',
                              transition: 'transform 0.2s ease',
                            }}
                          />
                        </td>
                        <td className="fournisseur-datacell" title={fournisseur.client}>
                          {fournisseur.client}
                        </td>
                        <td
                          className="fournisseur-datacell"
                          title={fournisseur.total_mntdt_client.toFixed(2)}
                        >
                          {fournisseur.total_mntdt_client.toFixed(2)}
                        </td>
                        <td
                          className="fournisseur-datacell"
                          title={fournisseur.total_mntdt_client.toFixed(2)}
                        >
                          estimation
                        </td>
                        <td
                          className="fournisseur-datacell"
                          title={fournisseur.total_reglement_client.toFixed(2)}
                        >
                          {fournisseur.total_reglement_client.toFixed(2)}
                        </td>
                        <td
                          className="fournisseur-datacell"
                          title={fournisseur.total_reglement_client.toFixed(2)}
                        >
                          {(
                            fournisseur.total_mntdt_client - fournisseur.total_reglement_client
                          ).toFixed(2)}
                        </td>
                      </tr>
                      {expandedIds.includes(fournisseur.id) && (
                        <ReglementExpand
                          selectedMonths={selectedMonths.map(m => m.value)}
                          fournisseur={fournisseur}
                        />
                      )}
                    </>
                  ))}
                {renderFournisseurs().length < 20 &&
                  Array.from({ length: 20 - renderFournisseurs().length }).map((_, index) => (
                    <tr key={`empty-row-${index}`}>
                      <td className="id-datacell"></td>
                      <td style={{ wordWrap: 'nowrap' }}></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          )}
        </div>
      </div>
    </Container>
  );
}
